export default __webpack_public_path__ + "static/media/ic-path.16d6db18.svg";